// src/components/Notification.tsx

import React, { useEffect } from 'react';
import { X } from 'lucide-react';

interface NotificationProps {
  message: string;
  type?: 'success' | 'error';
  onClose: () => void;
  duration?: number;
  /** Screen corner; default keeps existing callers unchanged */
  position?: 'bottom-right' | 'bottom-left' | 'top-right';
}

const POSITION_CLASS: Record<NonNullable<NotificationProps['position']>, string> = {
  'bottom-right': 'bottom-4 right-4',
  'bottom-left': 'bottom-4 left-4',
  'top-right': 'top-4 right-4',
};

const Notification: React.FC<NotificationProps> = ({ 
  message, 
  type = 'success', 
  onClose, 
  duration = 3000,
  position = 'bottom-right',
}) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  return (
    <div 
      className={`fixed ${POSITION_CLASS[position]} z-50 p-4 rounded-lg shadow-lg flex items-center justify-between gap-4 
        ${type === 'success' ? 'bg-green-50 text-green-800' : 'bg-red-50 text-red-800'}
        animate-[fadeIn_0.2s_ease-in,fadeOut_0.2s_ease-out_2.8s]`}
      style={{ minWidth: '300px' }}
    >
      <span>{message}</span>
      <button 
        onClick={onClose}
        className="text-current hover:opacity-70 transition-opacity"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Notification;